import type { QueryRequest } from '~/app/_repositories/query-types';

export const buildRequest = (
  storyId: string,
  isTrial: boolean
): QueryRequest => {
  const requestId = `FETCH_STORY_NOVEL_SCRIPT-${storyId}`;
  return {
    request_list: [
      {
        request_id: requestId,
        story_request: {
          id: storyId,
          require_story: {
            require_availability: true,
            require_status: true,
            require_novel_script: {
              require_full_html_body_script: isTrial ? undefined : true,
              require_trial_html_body_script: isTrial ? true : undefined,
            },
          },
        },
      },
    ],
  };
};
